import { computed } from '@ember/object';
import DeliveriesController from 'cio/controllers/deliveries';
import BroadcastTriggerModel from 'cio/models/broadcast-trigger';
import actionInfo from 'cio/utils/action-info';
import { task } from 'ember-concurrency';

export default class IndexController extends DeliveriesController {
  filterQueryParams = ['action', 'recipient'];
  queryParams = ['actionType', 'action', 'recipient', 'deliveryStatus', 'startTs', 'endTs'];
  detailRoute = 'broadcasts.broadcast.overview.broadcasts.trigger.delivery';

  declare model: BroadcastTriggerModel;

  @computed('model.messagingActions.[]')
  get otherMessagingActionGroups() {
    let actions = this.model.messagingActions.rejectBy('isEmail').rejectBy('isSplitTest').rejectBy('isAttributeAction');
    let types = actions.mapBy('type').uniq();

    return types.sort().map((type) => {
      return {
        actionInfo: actionInfo(type),
        actions: actions.filterBy('type', type),
      };
    });
  }

  onReportDownload = task(async () => {
    let link = await this.model.downloadErrorsLink({});
    window.open(link);
  });
}
